const DEFAULT_INTERVAL = 10; // 10s
const MIN_INTERVAL = 3; // 3s

export const getBannerLoopInterval = (interval: number) => {
  const _interval = !interval || interval < MIN_INTERVAL ? DEFAULT_INTERVAL : interval;
  return _interval * 1000;
};
